import { Component, EventEmitter, Input, Output } from '@angular/core';
// tslint:disable-next-line:nx-enforce-module-boundaries
import {
  CarouselImage,
  CarouselItem
} from '../../../../../../../../shared/ui/src/lib/shared/elements/image-carousel/image-carousel.component';

@Component({
  selector: 'kion-product-image-carousel',
  templateUrl: './product-image-carousel.component.html',
  styleUrls: ['./product-image-carousel.component.scss']
})
export class ProductImageCarouselComponent {
  @Input() items: CarouselItem[];
  @Input() activeSlide = 0;

  @Output('update') activeSlideEmitter: EventEmitter<number> = new EventEmitter<number>();

  updated(activeSlide: number) {
    console.log("item carusel activ element ",activeSlide)
    this.activeSlideEmitter.emit(activeSlide);
  }
}
